module.exports = __webpack_public_path__ + "img/image_placeholder.d992eb7.svg";